'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _d3Interpolate = require('d3-interpolate');

var _d3Timer = require('d3-timer');

var _easing = require('./easing');

var _easing2 = _interopRequireDefault(_easing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Transition = function (_Component) {
  _inherits(Transition, _Component);

  function Transition(props) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props));

    _this.start = function () {
      _this.timer = (0, _d3Timer.timer)(_this.animate);
    };

    _this.animate = function (elapsed) {
      _this.timer || _this.start();
      var _this$props = _this.props,
          duration = _this$props.duration,
          easing = _this$props.easing;

      var t = elapsed / duration;
      var nextState = void 0;
      if (t > 1) {
        nextState = _this.interpolator(1);
        _this.timer.stop();
      } else {
        nextState = _this.interpolator(_easing2.default[easing](t));
      }
      _this.setState({ props: nextState });
    };

    _this.state = {
      props: props.props
    };
    return _this;
  }

  _createClass(Transition, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.timer && this.timer.stop();
      this.interpolator = (0, _d3Interpolate.interpolateObject)(this.state.props, props.props);
      this.start();
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return children(this.state.props);
    }
  }]);

  return Transition;
}(_react.Component);

Transition.propTypes = {
  children: _propTypes2.default.func.isRequired,
  duration: _propTypes2.default.number,
  easing: _propTypes2.default.oneOf(Object.keys(_easing2.default)),
  props: _propTypes2.default.object.isRequired
};
Transition.defaultProps = {
  duration: 400,
  easing: 'cubicOut'
};
exports.default = Transition;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-prop-transition/lib/index.js
// module id = 313
// module chunks = 0